var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-svg-primary": "fill",
    d: "M833 217H167c-46 0-83 37-83 83l-1 500c0 46 38 83 84 83h666c46 0 84-37 84-83V300c0-46-38-83-84-83zm-16 177L522 578c-13 8-31 8-44 0L183 394c-10-7-16-18-16-30 0-28 30-45 54-30l279 174 279-174c24-15 54 2 54 30 0 12-6 23-16 30z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelope);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/envelope.253e66c975e3e477dbd98577192b7395.svg";